<script setup lang="ts">

import BaseMediaCard from './base/BaseMediaCard.vue';
import { getTranslation } from "@/utils/data-display-utils";
import { DTOContext } from "@/store/context.interface";

// PROPS
const props = defineProps<{
    supportingInfos: DTOContext[];
}>();

// EMITS
const emit = defineEmits<{
    (e: 'openAttachmentDialog'): void;
}>();


// FUNCTIONS
function openAttachmentDialog () {
    emit('openAttachmentDialog')
}
</script>

<template>
    <div class="attachments--container" v-for="info in supportingInfos">
        <BaseMediaCard
            :type="info.type"
            :title="getTranslation(info, 'title')"
            :content="getTranslation(info, 'content')"
            :link="info.link"
            @open-attachment-dialog="openAttachmentDialog"/>
    </div>
</template>

<style lang="scss">
.attachments--container {
    margin: $space-sm;
}
</style>